<!-- Outer page: white background -->
<div class="hp-outer-page">
  <div class="hp-phone-frame">
    <main class="hp-main" role="main">

      <div class="hp-input-area">

        <!-- Card header: spacer + centered title + spacer -->
        <div class="hp-card-header">
          <div class="hp-spacer"></div>
          <h2 class="hp-nav-title">パスワードの再設定</h2>
          <div class="hp-spacer"></div>
        </div>

        <!-- Description -->
        <p class="hp-nav-description">新しいパスワードを入力してください。</p>

        <!-- Server-side Error banner -->
        <div class="hp-banner-wrapper" *ngIf="serverError">
          <app-healthpicks-error-banner [message]="serverError"></app-healthpicks-error-banner>
        </div>

        <form class="hp-login-form" novalidate>
          <div class="hp-fields">

            <!-- New password -->
            <div class="hp-field-group" [class.hp-field-group--error]="errorMessages.password">
              <label class="hp-field-group__label">新しいパスワード</label>
              <div class="hp-field-group__input-wrap">
                <app-healthpicks-password-input
                  [(ngModel)]="password"
                  name="password"
                  placeholder="パスワード"
                ></app-healthpicks-password-input>
              </div>
              <app-healthpicks-field-error [message]="errorMessages.password"></app-healthpicks-field-error>
              <p class="hp-field-group__hint">半角の英小文字・英大文字・数字・記号（!@#$%^&amp;*）のうち3種類以上を含む、8文字以上のパスワードを入力してください。</p>
              
            </div>

            <!-- Confirm password -->
            <div class="hp-field-group" [class.hp-field-group--error]="confirmError">
              <label class="hp-field-group__label">新しいパスワード(確認)</label>
              <div class="hp-field-group__input-wrap">
                <app-healthpicks-password-input
                  [(ngModel)]="confirmationPassword"
                  name="confirm"
                  placeholder="パスワード(再入力)"
                ></app-healthpicks-password-input>
              </div>
              <app-healthpicks-field-error [message]="confirmError"></app-healthpicks-field-error>
            </div>

          </div>

          <div class="hp-actions">
            <button
              type="button"
              class="hp-btn-login"
              [disabled]="!password || !confirmationPassword"
              (click)="submitChangePassword()"
            >
              パスワードを変更する
            </button>
          </div>
        </form>

      </div>
    </main>
  </div>
</div>
